import { Link } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNavbar, changeToOpen, changeToClosed } from './navbar-slice';
import { selectUser } from '../features/user/user-slice';
import User from '../api/models/user';
import { plainToInstance } from 'class-transformer';
import { FiMenu } from 'react-icons/fi';

export const Navbar = () => {
  const { isAuthenticated, logout } = useAuth0();

  // Get the 'dispatch' method from the store
  const dispatch = useDispatch();
  const navbar = useSelector(selectNavbar);
  const appUser = plainToInstance(User, useSelector(selectUser));


  function drawerClickHandler(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
    if (navbar.drawerState === 'closed') {
      dispatch(changeToOpen());
    } else if (navbar.drawerState === 'open') {
      dispatch(changeToClosed());
    }
  }

  function linkClickHandler(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void {
    dispatch(changeToClosed());
  }

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <nav className='flex flex-col lg:flex-row flex-wrap w-full select-none lg:pl-8 lg:items-center font-semibold text-zinc-900 dark:text-neutral-300 bg-marble bg-cover bg-center dark:bg-neutral-900 dark:bg-blend-darken shadow-lg shadow-slate-900/80'>
      <div className='flex flex-row grow lg:grow-0 p-2 lg:mr-6 items-center'>
        <Link to={isAuthenticated ? '/portfolios/detail' : '/'} className='shrink'>
          <img className='h-10 w-10 mr-1 lg:h-14 lg:w-14 lg:mr-3' src={require('../images/logo.png')} alt='rebalancear'></img>
        </Link>
        <Link to={isAuthenticated ? '/portfolios/detail' : '/'} className='lg:text-3xl text-2xl tracking-tight grow'>
          Rebalancear
        </Link>
        <div className='lg:hidden'>
          <button onClick={drawerClickHandler} className='flex items-center py-1 px-2 border-zinc-800 hover:border-opacity-70'>
            <FiMenu size={20} className='text-zinc-900 dark:text-neutral-300' />
          </button>
        </div>
      </div>
      <div className='flex grow relative'>
        <div className={`z-50 absolute top-0 left-0 w-full pl-4 pr-3 bg-marble bg-cover bg-center overflow-hidden lg:relative lg:px-0 lg:flex lg:flex-1 lg:items-center lg:w-auto lg:border-t-0 transition-all duration-500 ease-in-out ${navbar.drawerState === 'closed' ? 'max-h-0 lg:max-h-fit' : 'max-h-96 border-t'}`}>
          <div className='lg:flex-1'></div>
          {appUser && <div className='select-none flex pt-2 pr-2 lg:pt-0 text-xs lg:text-lg font-normal'>Olá, {appUser.name}</div>}
          {appUser && <div className='hidden lg:flex h-8 ml-10 border-r-2 border-zinc-600'></div>}
          {appUser && <div className='hidden lg:flex mr-10'></div>}
          <div className={`flex flex-col lg:flex-row lg:items-center text-sm text-end lg:text-lg`}>
            {!isAuthenticated && (
              <Link to='/' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Página Inicial
              </Link>
            )}
            {!isAuthenticated && (
              <Link to='/importancia-de-rebalancear-portfolio' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Importância de Rebalancear
              </Link>
            )}
            {!isAuthenticated && (
              <Link to='/termos-de-uso' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Termos de Uso
              </Link>
            )}
            {!isAuthenticated && (
              <Link to='/portfolios/detail' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Login
              </Link>
            )}
            {isAuthenticated && (
              <Link to='/portfolios/detail' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Visualizar Portfolio
              </Link>
            )}
            {isAuthenticated && (
              <Link to='/portfolios/edit' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Alterar Portfolio
              </Link>
            )}
            {isAuthenticated && (
              <Link to='/portfolios/rebalance' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Rebalanceamento
              </Link>
            )}
            {isAuthenticated && (
              <Link to='/acoes' onClick={linkClickHandler} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Ações
              </Link>
            )}
            {isAuthenticated && (
              <Link to='' onClick={handleLogout} className='block mt-4 mb-1 lg:inline-block lg:mt-2 lg:mb-0 mr-2 lg:mr-10 hover:text-zinc-900/70'>
                Logout
              </Link>
            )}
            <div className='mt-4'></div>
          </div>
        </div>
      </div>
    </nav>
  )
}